import { plural } from "./words";

/** The share a registry entry states, or null while the registry has not answered. */
export function registryShare(value: string | undefined | null): number | null {
  if (value == null) return null;
  const share = Number.parseFloat(value);
  return Number.isFinite(share) && share >= 0 && share < 1 ? share : null;
}

/**
 * What the teacher makes of a documents set, said before the run starts (W9 census No. 4: a fixed
 * sample of 16 passages made 24 examples from 283 KB and nobody was told). The generator reads
 * every passage of every file, asks up to four questions of each — three to teach, one kept back
 * to check the model — and holds refusals to the registry's declared share. The number of
 * passages is known only once the teacher has split the files, so before the first preparation
 * the sentence states the rule; after it, the count the last preparation measured.
 */
export function preparationSentence(input: {
  files: number;
  refusalShare: number | null;
  heldBackShare: number | null;
  lastExamples: number | null;
}): string {
  const parts = [
    `The teacher reads every passage of the ${plural(input.files, "file")} — nothing is sampled — and writes up to 3 answered questions from each.`,
  ];
  if (input.refusalShare != null) {
    parts.push(`${Math.round(input.refusalShare * 100)} % of the examples teach the model to decline a question the passage does not answer.`);
  }
  if (input.heldBackShare != null && input.heldBackShare > 0) {
    parts.push(`${Math.round(input.heldBackShare * 100)} % of passages are kept back to test the model.`);
  }
  if (input.lastExamples != null) {
    parts.push(`The last preparation made ${plural(input.lastExamples, "example")}.`);
  }
  return parts.join(" ");
}
